<app-damage-report-step-header />
<div class="damage-report-card">
    <h3 class="c:blue-700 fw:regular">Zusammenfassung</h3>
    <div class="grid-container vertical-gutter-lg">
        @let controls = reportForm.controls;
        @if (controls.damageDate.value) {
            <app-portal-widget-details
                class="g-12 xs:g-6"
                heading="Schadensdatum"
                [detail]="controls.damageDate.value"
            />
        }
        @if (controls.location.value) {
            <app-portal-widget-details
                class="g-12 xs:g-6"
                heading="Ort"
                [detail]="controls.location.value"
            />
        }
        @if (controls.damageDescription.value) {
            <app-portal-widget-details
                class="g-12"
                heading="Schadensbeschreibung"
                [detail]="controls.damageDescription.value"
            />
        }
        @if (controls.eventDescription.value) {
            <app-portal-widget-details
                class="g-12"
                heading="Schadenshergang"
                [detail]="controls.eventDescription.value"
            />
        }
    </div>

    <button
        class="attachments-summary c:blue-700 m-48:b m-24:t"
        (click)="navigate.emit(fileAttachmentFormSlug)"
    >
        <i ctrlIcon="file"></i>
        <span>{{ filesForm.length }} Dateien beigefügt</span>
        <i ctrlIcon="chevron_right"></i>
    </button>

    <app-portal-action-buttons
        confirmText="Speichern"
        confirmIcon="save"
        (clickReject)="onPrev.emit()"
        (clickConfirm)="onSubmit.emit()"
        [isConfirmDisabled]="!reportForm.valid"
        [isUsedToSubmitForm]="false"
    />
</div>
